import { useEffect } from 'react';

// Component to manage favicon
const FaviconManager = () => {
  useEffect(() => {
    // Update favicon with a version timestamp to prevent caching
    const updateFavicon = () => {
      const timestamp = new Date().getTime();
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/png';
      link.rel = 'shortcut icon';
      link.href = `${process.env.PUBLIC_URL}/favicon.png?v=${timestamp}`;
      document.getElementsByTagName('head')[0].appendChild(link);
      
      // Also update apple-touch-icon
      const appleLink = document.querySelector("link[rel='apple-touch-icon']") || document.createElement('link');
      appleLink.rel = 'apple-touch-icon';
      appleLink.href = `${process.env.PUBLIC_URL}/assets/images/switch-logo.png?v=${timestamp}`;
      document.getElementsByTagName('head')[0].appendChild(appleLink);
    };
    
    // Run once on component mount
    updateFavicon();
    
    // Clean up (though not strictly necessary in this case)
    return () => {
      // No cleanup needed
    };
  }, []);
  
  // This component doesn't render anything
  return null;
};

export default FaviconManager; 